import { useEffect, useMemo } from "react";
import {
  GoabContainer,
  GoabFormItem,
  GoabRadioGroup,
  GoabRadioItem,
  GoabSpacer,
} from "@abgov/react-components";

import { useGetProgramEventListQuery } from "../../../store";
import { useGenerationForm } from "../../hooks";

export const EventSection = () => {
  const {
    form,
    fieldValues,
    fieldErrors,
    fieldTouches,
    handleRootChange,
    isReady,
  } = useGenerationForm();

  const { data: eventList } = useGetProgramEventListQuery(
    fieldValues.programId,
    { skip: !fieldValues.programId }
  );
  const safeEventList = useMemo(() => {
    return eventList ?? [];
  }, [eventList]);

  useEffect(() => {
    if (fieldValues.programId && safeEventList.length > 0) {
      const firstEventValue = safeEventList[0]?.code ?? "";
      // Only set initial value if no applicationType is currently selected
      if (!fieldValues.applicationType) {
        handleRootChange("applicationType", firstEventValue);
        setTimeout(() => form.validateForm());
      }
    }
  }, [
    form,
    fieldValues.programId,
    safeEventList,
    handleRootChange,
    fieldValues.applicationType,
  ]);

  // Early return if form not ready.
  if (!isReady) return null;

  const eventError =
    fieldTouches.applicationType && fieldErrors.applicationType;

  return (
    <>
      <GoabContainer accent="thin">
        <h3>Select the event you are applying for:</h3>

        <GoabSpacer vSpacing="l" />
        <GoabFormItem error={fieldErrors.applicationType}>
          <GoabRadioGroup
            name="applicationType"
            onChange={({name, value}) => {
              handleRootChange(name, value);
              // Needed for radio buttons
              setTimeout(() => form.validateForm());
            }}
            orientation="vertical"
            error={!!eventError}
            value={fieldValues.applicationType}
          >
            {safeEventList.length > 0 ? (
              safeEventList.map((event) => (
                <GoabRadioItem
                  key={event.id}
                  value={event.code}
                  label={event.name}
                />
              ))
            ) : (
              <>No events found for program.</>
            )}
          </GoabRadioGroup>
        </GoabFormItem>
      </GoabContainer>
      <GoabSpacer vSpacing="2xs" />
    </>
  );
};
